<template>
  <div class="right-chart-3" id="right-chart-3"></div>
</template>

<script>
import { querysbtrccb } from '@/api/modules/dataView.js'
export default {
  name: 'RightChart3',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const sbtrccbData = await querysbtrccb(this.date)
      const data_month = []
      const data_ct = []
      const data_mri = []
      const data_zxjsq = []
      sbtrccbData.forEach(item => {
        data_month.push(item.data_timestamp || '其他')
        data_ct.push(item.ct_trccb || 0)
        data_mri.push(item.mri_trccb || 0)
        data_zxjsq.push(item.zxjsq_trccb || 0)
      })
      const echartsDom = document.getElementById('right-chart-3')
      this.chart = this.$echarts.init(echartsDom)
      const options = {
        title: {
          text: '设备投入产出比',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['CT类', 'MR类', '直线加速器'],
          top: '30px',
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#fff',
          },
          boundaryGap: false,
          data: data_month,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
          },
        },
        series: [
          {
            name: 'CT类',
            type: 'line',
            stack: '总量',
            data: data_ct,
          },
          {
            name: 'MR类',
            type: 'line',
            stack: '总量',
            data: data_mri,
          },
          {
            name: '直线加速器',
            type: 'line',
            stack: '总量',
            data: data_zxjsq,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.right-chart-3 {
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;
}
</style>
